
const homePageSteps=[
          {
            popover: {
              title: 'Welcome',
              description: 'Welcome to University Intelligence',
              side: 'over',
              align: 'center',
            },
          },
          {
            element: '.select-client',
            popover: {
              title: 'Select Client',
              description: 'Please select Client',
              position: 'right',
            },
          },
        ]


    

export {homePageSteps}